import { Tab } from "bootstrap";
import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";

export const StandardsDetailsFaq = () => {
    const [isOpen, setIsOpen] = useState({
      collapseOne: true,
      collapseTwo: false,
      collapseThree: false,
      collapseFour: false,
      collapseFive: false,
      collapseSix: false,
      collapseSeven: false,
      collapseEight: false,
      collapseNine: false,
      collapseTen: false,
      collapseEleven: false,
      collapseTwelve: false,
      collapseThirteen: false,
      collapseForteen: false,
      collapseFifteen: false,
      collapseSixteen: false,
      collapseSeventeen: false,
      collapseEighteen: false,
      collapseNineteen: false,
      collapseTwenty: false,
      collapseTwentyOne: false,
      collapseTwentyTwo: false,
      collapseTwentyThree: false,
      collapseTwentyFour: false,
      collapseTwentyFive: false,
      collapseTwentySix: false,
      collapseTwentySeven: false,
      collapseTwentyEight: false,
      collapseTwentyNine: false,
      collapseThirty: false,
      collapseThirtyOne: false,
      collapseThirtyTwo: false,
      collapseThirtyThree: false,
    });
  
    const toggleCollapse = (collapseId) => {
      setIsOpen((prev) => ({
        ...prev,
        [collapseId]: !prev[collapseId],
      }));
    };
  return (
    <div className="accordion-wrap-three">
      <div className="accordion" id="accordionExample">
        <div className="accordion-item">
          <h2 className="accordion-header"  id="headingOne">
            <button
              className={`accordion-button ${isOpen.collapseOne ? "" : "collapsed"}`}
              
              type="button"
              onClick={() => toggleCollapse("collapseOne")}
              aria-expanded={isOpen.collapseOne ? "true" : "false"}
              aria-controls="collapseOne"
              style={isOpen.collapseOne ? { backgroundColor: "#0055FF" } : {}}

              
            >
              ISO 9001:2015 (Quality Management System)
            </button>
          </h2>
          <div
            id="collapseOne"
            className={`accordion-collapse collapse ${isOpen.collapseOne ? "show" : ""}`}

            //className="accordion-collapse collapse show"
            aria-labelledby="headingOne"

            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              ISO 9001:2015 specifies requirements for a quality management system when an organization:
              
            </p>
            <br/>
            <div className="standards-padding">
                    <p className="list-item">

                    <b>a.</b> needs to demonstrate its ability to consistently provide products and services that 
                      meet customer and applicable statutory and regulatory requirements, and
                      
                    </p>
                <p className="list-item">
                    <b>b.</b> aims to enhance customer satisfaction through the effective application of the system, 
                including processes for improvement of the system and the assurance of conformity to customer and applicable statutory and regulatory requirements.
                </p>
            </div>
            <br/>
            <p>All the requirements of ISO 9001:2015 are generic and are intended to be applicable 
              to any organization, regardless of its type or size, or the products and services it provides.</p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseTwo ? "" : "collapsed"}`}
              type="button"
           

              onClick={() => toggleCollapse("collapseTwo")}
              aria-expanded={isOpen.collapseTwo ? "true" : "false"}
              aria-controls="collapseTwo"
              style={isOpen.collapseTwo ? { backgroundColor: "#0055FF" } : {}}

            >
               ISO 14001:2015 (Environmental Management System)
            </button>
          </h2>
          <div
            id="collapseTwo"
            className={`accordion-collapse collapse ${isOpen.collapseTwo ? "show" : ""}`}

           // className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              ISO 14001:2015 specifies the requirements for an environmental management system that an 
              organization can use to enhance its environmental performance. ISO 14001:2015 is intended 
              for use by an organization seeking to manage its environmental responsibilities in a systematic
              manner that contributes to the environmental pillar of sustainability.
              </p>
              <br/>
              <p>
              ISO 14001:2015 helps an organization achieve the intended outcomes of its environmental 
              management system, which provide value for the environment, the organization itself and 
              interested parties. Consistent with the organization’s environmental policy, the intended 
              outcomes of an environmental management system include:
              </p>
              <br/>
              <p>
                <ul>
                  <li>
                  enhancement of environmental performance;
                  </li>
                  <li>
                  fulfilment of compliance obligations;
                  
                  </li>
                  <li>
                  achievement of environmental objectives.
                  </li>
                </ul>
              </p>

              <br/>
              <p>
              ISO 14001:2015 is applicable to any organization, regardless of size, type and nature, and applies
               to the environmental aspects of its activities, products and services that the organization 
               determines it can either control or influence considering a life cycle perspective. 
               ISO 14001:2015 does not state specific environmental performance criteria.
               </p>
               <br/>
               <p>
               ISO 14001:2015 can be used in whole or in part to systematically improve environmental management.
                Claims of conformity to ISO 14001:2015, however, are not acceptable unless all its 
                requirements are incorporated into an organization’s environmental management system and 
                fulfilled without exclusion.
              </p>
              
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseThree ? "" : "collapsed"}`}
              type="button"
           //   data-bs-toggle="collapse"
             // data-bs-target="#collapseThree"
             // aria-expanded="false"
              //aria-controls="collapseThree"
              onClick={() => toggleCollapse("collapseThree")}
              aria-expanded={isOpen.collapseThree ? "true" : "false"}
              aria-controls="collapseThree"
              style={isOpen.collapseThree ? { backgroundColor: "#0055FF" } : {}}

            > 
              ISO/IEC 17025:2017 (General requirements for the competence of testing and calibration laboratories)
            </button>
          </h2>
          <div
            id="collapseThree"
          //  className="accordion-collapse collapse"
          className={`accordion-collapse collapse ${isOpen.collapseThree ? "show" : ""}`}
  
          data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              ISO/IEC 17025:2017 specifies the general requirements for the competence, impartiality and 
              consistent operation of laboratories.
              </p><br/>
              <p>ISO/IEC 17025:2017 is applicable to all organizations performing laboratory activities, 
                regardless of the number of personnel.</p><br/>
              <p>Laboratory customers, regulatory authorities, organizations and schemes 
                using peer-assessment, accreditation bodies, and others use ISO/IEC 17025:2017 
                in confirming or recognizing the competence of laboratories.</p><br/>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseFour ? "" : "collapsed"}`}
              type="button"
          //    data-bs-toggle="collapse"
            //  data-bs-target="#collapseFour"
             // aria-expanded="false"
             // aria-controls="collapseFour"
             onClick={() => toggleCollapse("collapseFour")}
              aria-expanded={isOpen.collapseFour ? "true" : "false"}
              aria-controls="collapseFour"
              style={isOpen.collapseFour ? { backgroundColor: "#0055FF" } : {}}

             
            >
            ISO 13485:2016 (Medical devices — Quality management systems — Requirements for 
            regulatory purposes)
            </button>
          </h2>
          <div
            id="collapseFour"
            className={`accordion-collapse collapse ${isOpen.collapseFour ? "show" : ""}`}

          //  className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              ISO 13485:2016 specifies requirements for a quality management system where an organization 
              needs to demonstrate its ability to provide medical devices and related services 
              that consistently meet customer and applicable regulatory requirements. Such organizations 
              can be involved in one or more stages of the life-cycle, including design and development, 
              production, storage and distribution, installation, or servicing of a medical device and design
               and development or provision of associated activities (e.g. technical support). 
               ISO 13485:2016 can also be used by suppliers or external parties that provide product, 
               including quality management system-related services to such organizations.
               </p>
               <br/>  

              <p>
              Requirements of ISO 13485:2016 are applicable to organizations regardless of their size 
              and regardless of their type except where explicitly stated. Wherever requirements are 
              specified as applying to medical devices, the requirements apply equally to associated 
              services as supplied by the organization.
              </p>
              <br/>
              <p>
              The processes required by ISO 13485:2016 that are applicable to the organization, but are not 
              performed by the organization, are the responsibility of the organization and are accounted 
              for in the organization’s quality management system by monitoring, maintaining, and 
              controlling the processes.
              </p>
            </div>
          </div>
        </div>
       
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseFive ? "" : "collapsed"}`}
              type="button"
              //data-bs-toggle="collapse"
              //data-bs-target="#collapseFive"
              //aria-expanded="false"
              //aria-controls="collapseFive"
              onClick={() => toggleCollapse("collapseFive")}
              aria-expanded={isOpen.collapseFive ? "true" : "false"}
              aria-controls="collapseFive"
              style={isOpen.collapseFive ? { backgroundColor: "#0055FF" } : {}}

            >
ISO 21001:2018 (Educational organizations — Management systems for educational organizations — Requirements with guidance for use)            </button>
          </h2>
          <div
            id="collapseFive"
            className={`accordion-collapse collapse ${isOpen.collapseFive ? "show" : ""}`}

       //     className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              ISO 21001:2018 specifies requirements for a management system for educational 
              organizations (EOMS) when such an organization:
              </p>
          <br/>
              <div className="standards-padding">
              <p className="list-item">
                <b>a.</b> needs to demonstrate its ability to support the acquisition and development of competence 
              through teaching, learning or research;
              </p>
              
              <p className="list-item"><b>b. </b>aims to enhance satisfaction of learners, other beneficiaries and staff through the 
                effective application of its EOMS, including processes for improvement of the system and 
                assurance of conformity to the requirements of learners and other beneficiaries.</p>
              </div>
              <br/>
              <p>
              All requirements of ISO 21001:2018 are generic and intended to be applicable to any 
              organization that uses a curriculum to support the development of competence through 
              teaching, learning or research, regardless of the type, size or method of delivery.
              </p>
              <br/>
              <p>
              ISO 21001:2018 can be applied to educational organizations within larger organizations 
              whose core business is not education, such as professional training departments.
              </p>
              <br/>
              <p>
              ISO 21001:2018 does not apply to organizations that only produce or 
              manufacture educational products.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseSix ? "" : "collapsed"}`}
              type="button"
            //  data-bs-toggle="collapse"
             // data-bs-target="#collapseSix"
              //aria-expanded="false"
              //aria-controls="collapseSix"
              onClick={() => toggleCollapse("collapseSix")}
              aria-expanded={isOpen.collapseSix ? "true" : "false"}
              aria-controls="collapseSix"
              style={isOpen.collapseSix ? { backgroundColor: "#0055FF" } : {}}

            >
            ISO 21500:2012 (Guidance on project management)
            </button>
          </h2>
          <div
            id="collapseSix"
            className={`accordion-collapse collapse ${isOpen.collapseSix ? "show" : ""}`}

           // className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              ISO 21500:2012 provides guidance for project management and can be used by any type of
              organization, including public, private or community organizations, and for any type of 
              project, irrespective of complexity, size or duration.
              </p>
              <br/>
              <p>
              ISO 21500:2012 provides high-level description of concepts and processes that are 
              considered to form good practice in project management. Projects are placed in the 
              context of programmes and project portfolios, however, ISO 21500:2012 does not provide 
              detailed guidance on the management of programmes and project portfolios. Topics pertaining 
              to general management are addressed only within the context of project management.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseSeven ? "" : "collapsed"}`}
              type="button"
          //    data-bs-toggle="collapse"
           //   data-bs-target="#collapseSeven"
            // aria-expanded="false"
             //</h2> aria-controls="collapseSeven"
             onClick={() => toggleCollapse("collapseSeven")}
              aria-expanded={isOpen.collapseSeven ? "true" : "false"}
              aria-controls="collapseSeven"
              style={isOpen.collapseSeven ? { backgroundColor: "#0055FF" } : {}}

            >
              ISO 22000:2018 (Food safety management systems — Requirements for any organization in the food chain)
            </button>
          </h2>
          <div
            id="collapseSeven"
            className={`accordion-collapse collapse ${isOpen.collapseSeven ? "show" : ""}`}

            //className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              This document specifies requirements for a food safety management system (FSMS) to 
              enable an organization that is directly or indirectly involved in the food chain:
              </p>

              <br/>
              <div className="standards-padding">
              <p className="list-item">
              <b>a.</b> to plan, implement, operate, maintain and update a FSMS providing products and 
              services that are safe, in accordance with their intended use;
              </p>

             
              <p className="list-item"><b>b.</b>
              to demonstrate compliance with applicable statutory and regulatory food safety requirements;
              </p>
         
              <p className="list-item"><b>c.</b>
              to evaluate and assess mutually agreed customer food safety requirements and to demonstrate 
              conformity with them;</p>
       
              <p className="list-item"><b>d.</b>
              to effectively communicate food safety issues to interested parties within the food chain;
              </p>
         
              <p className="list-item"><b>e.</b>
              to ensure that the organization conforms to its stated food safety policy;
              </p>
          
              <p className="list-item"><b>f.</b>
              to demonstrate conformity to relevant interested parties;
              </p>
        
              <p className="list-item"><b>g.</b>
              to seek certification or registration of its FSMS by an external organization, 
              or make a self-assessment or self-declaration of conformity to this document.
              </p>

              </div>
              <br/>
              <p>All requirements of this document are generic and are intended to be applicable to 
                all organizations in the food chain, regardless of size and complexity. Organizations 
                that are directly or indirectly involved include, but are not limited to, feed producers,
                 animal food producers, harvesters of wild plants and animals, farmers, producers of 
                 ingredients, food manufacturers, retailers, and organizations providing food services,
                  catering services, cleaning and sanitation services, transportation, storage and 
                  distribution services, suppliers of equipment, cleaning and disinfectants, packaging 
                  materials and other food contact materials.</p> <br/>
                  <p>
                  This document allows any organization, including small and/or less developed organizations
                 (e.g. a small farm, a small packer-distributor, a small retail or food service outlet) 
                 to implement externally-developed elements in their FSMS.
                  </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseEight ? "" : "collapsed"}`}
              type="button"
            //  data-bs-toggle="collapse"
             // data-bs-target="#collapseEight"
             // aria-expanded="false"
            //  aria-controls="collapseEight"
            onClick={() => toggleCollapse("collapseEight")}
              aria-expanded={isOpen.collapseEight ? "true" : "false"}
              aria-controls="collapseEight"
              style={isOpen.collapseEight ? { backgroundColor: "#0055FF" } : {}}

            >
              ISO/IEC 27001:2013 (Information technology — Security techniques — Information security management systems – Requirements)
            </button>
          </h2>
          <div
            id="collapseEight"
            className={`accordion-collapse collapse ${isOpen.collapseEight ? "show" : ""}`}

            //className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              ISO/IEC 27001:2013 specifies the requirements for establishing, implementing, 
              maintaining and continually improving an information security management system within the 
              context of the organization. It also includes requirements for the assessment and treatment 
              of information security risks tailored to the needs of the organization. The requirements set 
              out in ISO/IEC 27001:2013 are generic and are intended to be applicable to all organizations,
               regardless of type, size or nature.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseNine ? "" : "collapsed"}`}
              type="button"
             // data-bs-toggle="collapse"
              //data-bs-target="#collapseNine"
              //aria-expanded="false"
              //aria-controls="collapseNine"
              onClick={() => toggleCollapse("collapseNine")}
              aria-expanded={isOpen.collapseNine ? "true" : "false"}
              aria-controls="collapseNine"
              style={isOpen.collapseNine ? { backgroundColor: "#0055FF" } : {}}

            >
              ISO 22301:2012 (Societal security — Business continuity management systems – Requirements)
            </button>
          </h2>
          <div
            id="collapseNine"
            className={`accordion-collapse collapse ${isOpen.collapseNine ? "show" : ""}`}

         //   className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              ISO 22301:2012 specifies requirements to plan, establish, implement, operate, monitor, review, 
              maintain and continually improve a documented management system to protect against, reduce 
              the likelihood of occurrence, prepare for, respond to, and recover from disruptive incidents 
              when they arise.
              </p>
              <br/>
              <p>
              The requirements specified in ISO 22301:2012 are generic and intended to be applicable 
              to all organizations, or parts thereof, regardless of type, size and nature of the organization.
              The extent of application of these requirements depends on the organization’s operating 
              environment and complexity.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseTen ? "" : "collapsed"}`}
              type="button"
         //     data-bs-toggle="collapse"
           //   data-bs-target="#collapseTen"
          //    aria-expanded="false"
            //  aria-controls="collapseTen"
            onClick={() => toggleCollapse("collapseTen")}
              aria-expanded={isOpen.collapseTen ? "true" : "false"}
              aria-controls="collapseTen"
              style={isOpen.collapseTen ? { backgroundColor: "#0055FF" } : {}}

            >
              ISO 26000:2010 (Guidance on social responsibility)

            </button>
          </h2>
          <div
            id="collapseTen"
            className={`accordion-collapse collapse ${isOpen.collapseTen ? "show" : ""}`}

          //  className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              ISO 26000:2010 provides guidance to all types of organizations, regardless of their 
              size or location, on:
              </p>
              <br/>
              <ul>
                <li>
                concepts, terms and definitions related to social responsibility;

                </li>
                <li>
                the background, trends and characteristics of social responsibility;

                  </li>
                  <li>
                  principles and practices relating to social responsibility;

                  </li>
                  <li>
                  the core subjects and issues of social responsibility;

                  </li>
                  <li>
                  integrating, implementing and promoting socially responsible behaviour 
                  throughout the organization and, through its policies and practices, within 
                  its sphere of influence;

                  </li>
                  <li>
                  identifying and engaging with stakeholders; and

                  </li>
                  <li>
                  communicating commitments, performance and other information related to social 
                  responsibility.

                  </li>

              </ul>
              <br/>
              <p>
              ISO 26000:2010 is intended to assist organizations in contributing to sustainable development. 
              It is intended to encourage them to go beyond legal compliance, recognizing that compliance
               with law is a fundamental duty of any organization and an essential part of their social 
               responsibility. It is intended to promote common understanding in the field of social 
               responsibility, and to complement other instruments and initiatives for social responsibility,
                not to replace them.
              </p>
              <br/>
              <p>
              In applying ISO 26000:2010, it is advisable that an organization take into consideration societal,
               environmental, legal, cultural, political and organizational diversity, as well as differences
                in economic conditions, while being consistent with international norms of behaviour.
              </p>
              <br/>
              <p>
              ISO 26000:2010 is not a management system standard. It is not intended or appropriate for 
              certification purposes or regulatory or contractual use. Any offer to certify, or claims to 
              be certified, to ISO 26000 would be a misrepresentation of the intent and purpose and a 
              misuse of ISO 26000:2010. As ISO 26000:2010 does not contain requirements, any such 
              certification would not be a demonstration of conformity with ISO 26000:2010.
              </p>
              <br/>
              <p>
              ISO 26000:2010 is intended to provide organizations with guidance concerning social 
              responsibility and can be used as part of public policy activities. However, for the purposes 
              of the Marrakech Agreement establishing the World Trade Organization (WTO), it is not intended 
              to be interpreted as an “international standard”, “guideline” or “recommendation”, nor is it 
              intended to provide a basis for any presumption or finding that a measure is consistent with 
              WTO obligations. Further, it is not intended to provide a basis for legal actions, complaints,
               defences or other claims in any international, domestic or other proceeding, nor is it 
               intended to be cited as evidence of the evolution of customary international law.
              </p>
              <br/>
              <p>
              ISO 26000:2010 is not intended to prevent the development of national standards that are 
              more specific, more demanding, or of a different type.
              </p>
            </div>
          </div>
        </div>
        <br/>
      
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseEleven ? "" : "collapsed"}`}
              type="button"
           //   data-bs-toggle="collapse"
             // data-bs-target="#collapseEleven"
             // aria-expanded="false"
             // aria-controls="collapseEleven"
              onClick={() => toggleCollapse("collapseEleven")}
              aria-expanded={isOpen.collapseEleven ? "true" : "false"}
              aria-controls="collapseEleven"
              style={isOpen.collapseEleven ? { backgroundColor: "#0055FF" } : {}}

              
            >
ISO 29993:2017 (Learning services outside formal education — Service requirements)

            </button>
          </h2>
          <div
            id="collapseEleven"
            className={`accordion-collapse collapse ${isOpen.collapseEleven ? "show" : ""}`}

          //  className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              ISO 29993:2017 specifies requirements for learning services outside formal education, 
              including all types of life-long learning (e.g. vocational training and in-company training, 
              either outsourced or in-house). These include any learning services provided by a learning 
              service provider (LSP) that are addressed to learners themselves, as well as to 
              sponsors who are acquiring the services on behalf of the learners. The key features 
              of these kinds of services are that the goals of learning are defined and the 
              services are evaluated, and that they involve interaction with the learner. 
              The learning can be face-to-face, mediated by technology, or a blend of both.

               </p>
              <br/>
              <p>
              In cases where the learning service provider is part of an organization that delivers 
              products (i.e. goods and services) in addition to learning services, ISO 29993:2017 only 
              applies to learning services.
              </p>
              <br/>
              <p>
              ISO 29993:2017 is not aimed at schools, colleges and universities providing learning services 
              as part of a formal education system, but it can be useful to them as a tool for reflection 
              and self-evaluation.

              </p>
            </div>
          </div>
        </div>
        <br/>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseTwelve ? "" : "collapsed"}`}
              type="button"
           //   data-bs-toggle="collapse"
             // data-bs-target="#collapseTwelve"
             // aria-expanded="false"
             // aria-controls="collapseTwelve"
              onClick={() => toggleCollapse("collapseTwelve")}
              aria-expanded={isOpen.collapseTwelve ? "true" : "false"}
              aria-controls="collapseTwelve"
              style={isOpen.collapseTwelve ? { backgroundColor: "#0055FF" } : {}}

            >
        ISO 31000:2018 (Risk management – Guidelines)


            </button>
          </h2>
          <div
            id="collapseTwelve"
            className={`accordion-collapse collapse ${isOpen.collapseTwelve ? "show" : ""}`}

           // className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              ISO 31000:2018 provides guidelines on managing risk faced by organizations. The application of 
              these guidelines can be customized to any organization and its context.
               </p>   
              <br/>
              <p>
              ISO 31000:2018 provides a common approach to managing any type of risk and is not 
              industry or sector specific.
              </p>
              <br/>
              <p>
              ISO 31000:2018 can be used throughout the life of the organization and can be 
              applied to any activity, including decision-making at all levels.
              </p>
            </div>
          </div>
        </div>
        <br/>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseThirteen ? "" : "collapsed"}`}
              type="button"
           //   data-bs-toggle="collapse"
             // data-bs-target="#collapseThirteen"
             // aria-expanded="false"
             // aria-controls="collapseThirteen"
              onClick={() => toggleCollapse("collapseThirteen")}
              aria-expanded={isOpen.collapseTwelve ? "true" : "false"}
              aria-controls="collapseThirteen"
              style={isOpen.collapseThirteen ? { backgroundColor: "#0055FF" } : {}}

            >
            ISO 39001:2012 (Road traffic safety (RTS) management systems — Requirements with guidance for use


            </button>
          </h2>
          <div
            id="collapseThirteen"
            className={`accordion-collapse collapse ${isOpen.collapseThirteen ? "show" : ""}`}

            //className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              ISO 39001:2012 specifies requirements for a road traffic safety (RTS) management system to 
              enable an organization that interacts with the road traffic system to reduce death and serious 
              injuries related to road traffic crashes which it can influence. The requirements in 
              ISO 39001:2012 include development and implementation of an appropriate RTS policy, 
              development of RTS objectives and action plans, which take into account legal and other 
              requirements to which the organization subscribes, and information about elements and criteria
              related to RTS that the organization identifies as those which it can control and those 
              which it can influence.  
              </p>
            </div>
          </div>
        </div>
        <br/>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseForteen ? "" : "collapsed"}`}
              type="button"
           //   data-bs-toggle="collapse"
             // data-bs-target="#collapseForteen"
             // aria-expanded="false"
             // aria-controls="collapseForteen"
              onClick={() => toggleCollapse("collapseForteen")}
              aria-expanded={isOpen.collapseForteen ? "true" : "false"}
              aria-controls="collapseForteen"
              style={isOpen.collapseForteen ? { backgroundColor: "#0055FF" } : {}}

            >
           ISO 45001:2018 (Occupational health and safety management systems — Requirements with guidance for use)
            </button>
          </h2>
          <div
            id="collapseForteen"
            className={`accordion-collapse collapse ${isOpen.collapseForteen ? "show" : ""}`}

            //className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              ISO 45001:2018 specifies requirements for an occupational health and safety (OH&S) management 
              system, and gives guidance for its use, to enable organizations to provide safe and 
              healthy workplaces by preventing work-related injury and ill health, as well as by proactively 
              improving its OH&S performance.
              </p>
              <br/>
              <p>
              ISO 45001:2018 is applicable to any organization that wishes to establish, implement and maintain
               an OH&S management system to improve occupational health and safety, eliminate hazards and 
               minimize OH&S risks (including system deficiencies), take advantage of OH&S opportunities, 
               and address OH&S management system nonconformities associated with its activities.
               </p>
              <br/>
              <p>
              ISO 45001:2018 helps an organization to achieve the intended outcomes of its OH&S management 
              system. Consistent with the organization’s OH&S policy, the intended outcomes of an OH&S 
              management system include:
              </p>
              <br/>
              <div className="standards-padding">
                <p className="list-item">
                <b>a.</b> continual improvement of OH&S performance;
                </p>
                
                <p className="list-item">
                <b>b.</b>fulfilment of legal requirements and other requirements;
                </p>
                
                <p className="list-item">
                <b>c.</b>achievement of OH&S objectives.
                </p>
                
              </div>
              <br/>
              <p>ISO 45001:2018 is applicable to any organization regardless of its size, type and 
                activities. It is applicable to the OH&S risks under the organization’s control, 
                taking into account factors such as the context in which the organization operates 
                and the needs and expectations of its workers and other interested parties.</p>
                <br/>
              <p>ISO 45001:2018 does not state specific criteria for OH&S performance, nor is it 
                prescriptive about the design of an OH&S management system.</p><br/>
              <p>ISO 45001:2018 enables an organization, through its OH&S management system, to 
                integrate other aspects of health and safety, such as worker wellness/wellbeing.</p><br/>
              <p>ISO 45001:2018 does not address issues such as product safety, property damage 
                or environmental impacts, beyond the risks to workers and other relevant 
                interested parties.</p><br/>
              <p>ISO 45001:2018 can be used in whole or in part to systematically improve 
                occupational health and safety management. However, claims of conformity to this 
                document are not acceptable unless all its requirements are incorporated into an 
                organization’s OH&S management system and fulfilled without exclusion.</p><br/>
            </div>
          </div>
        </div>
        <br/>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
               className={`accordion-button ${isOpen.collapseFifteen ? "" : "collapsed"}`}
               type="button"
            //   data-bs-toggle="collapse"
              // data-bs-target="#collapseFifteen"
              // aria-expanded="false"
              // aria-controls="collapseFifteen"
               onClick={() => toggleCollapse("collapseFifteen")}
               aria-expanded={isOpen.collapseFifteen ? "true" : "false"}
               aria-controls="collapseFifteen"
               style={isOpen.collapseFifteen ? { backgroundColor: "#0055FF" } : {}}
 
            >
              ISO 41001:2018 (Facility management — Management systems)

            </button>
          </h2>
          <div
            id="collapseFifteen"
            className={`accordion-collapse collapse ${isOpen.collapseFifteen ? "show" : ""}`}

           // className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              ISO 41001:2018 specifies the requirements for a facility management (FM) system 
              when an organization:
              </p>
              <br/>
              <div className="standards-padding">
                <p className="list-item"><b>a.</b>needs to demonstrate effective and efficient delivery of FM that 
                supports the objectives of the demand organization;</p>
                <p className="list-item"><b>b.</b>aims to consistently meet the needs of interested parties and 
                applicable requirements;</p>
                <p className="list-item"><b>c.</b>aims to be sustainable in a globally-competitive environment.</p>
              </div>
              <br/>
              <p>
              The requirements specified in ISO 41001:2018 are non-sector specific and intended to be 
              applicable to all organizations, or parts thereof, whether public or private sector, and 
              regardless of the type, size and nature of the organization or geographical location.              
              </p>
            </div>
          </div>
        </div>
        <br/>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
             className={`accordion-button ${isOpen.collapseSixteen ? "" : "collapsed"}`}
             type="button"
          //   data-bs-toggle="collapse"
            // data-bs-target="#collapseSixteen"
            // aria-expanded="false"
            // aria-controls="collapseSixteen"
             onClick={() => toggleCollapse("collapseSixteen")}
             aria-expanded={isOpen.collapseSixteen ? "true" : "false"}
             aria-controls="collapseSixteen"
             style={isOpen.collapseSixteen ? { backgroundColor: "#0055FF" } : {}}
            >
            ISO 50001:2018 (Energy management systems)
            </button>
          </h2>
          <div
            id="collapseSixteen"
            className={`accordion-collapse collapse ${isOpen.collapseSixteen ? "show" : ""}`}

           // className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              This document specifies requirements for establishing, implementing, maintaining and improving 
              an energy management system (EnMS). The intended outcome is to enable an organization to follow
               a systematic approach in achieving continual improvement of energy performance and the EnMS.
              </p>
              <br/>
             <p>
             This document:
              </p>
              <div className="standards-padding">
                <p className="list-item"><b>a.</b>is applicable to any organization regardless of its type, size, 
                complexity, geographical location, organizational culture or the products and 
                services it provides;</p>
                <p className="list-item"><b>b.</b>is applicable to activities affecting energy performance that are 
                managed and controlled by the organization;</p>
                <p className="list-item"><b>c.</b> is applicable irrespective of the quantity, use, or types of energy consumed;</p>
                <p className="list-item"><b>d.</b>requires demonstration of continual energy performance improvement, but does not define levels of energy performance improvement to be achieved;</p>
                <p className="list-item"><b>e.</b>can be used independently, or be aligned or integrated with other management systems.</p>
              </div>
            </div>
          </div>
        </div>
        <br/>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseSeventeen ? "" : "collapsed"}`}
              type="button"
           //   data-bs-toggle="collapse"
             // data-bs-target="#collapseSeventeen"
             // aria-expanded="false"
             // aria-controls="collapseSeventeen"
              onClick={() => toggleCollapse("collapseSeventeen")}
              aria-expanded={isOpen.collapseSeventeen ? "true" : "false"}
              aria-controls="collapseSeventeen"
              style={isOpen.collapseSeventeen ? { backgroundColor: "#0055FF" } : {}}
            >
              IATF 16949:2016 (Automotive quality management systems)
            </button>
          </h2>
          <div
            id="collapseSeventeen"
            className={`accordion-collapse collapse ${isOpen.collapseSeventeen ? "show" : ""}`}

           // className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              The automotive industry has always needed to demonstrate high levels of safety and quality. 
              With increasingly complex supply chains that span the world, it’s important that you can 
              demonstrate your commitment to quality and on-time delivery. Following some of the challenges 
              faced by the automotive industry in recent years, IATF 16949:2016 builds upon ISO 9001:2015 
              with supplementary requirements designed to help automotive Original Equipment Manufacturers 
              (OEMs) and suppliers consistently produce quality products and meet customer needs
              </p>
            </div>
          </div>
        </div>
        <br/>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseEighteen ? "" : "collapsed"}`}
              type="button"
           //   data-bs-toggle="collapse"
             // data-bs-target="#collapseEighteen"
             // aria-expanded="false"
             // aria-controls="collapseEighteen"
              onClick={() => toggleCollapse("collapseEighteen")}
              aria-expanded={isOpen.collapseEighteen ? "true" : "false"}
              aria-controls="collapseEighteen"
              style={isOpen.collapseEighteen ? { backgroundColor: "#0055FF" } : {}}
            >
          AS9100D (Aero Space quality management systems)

            </button>
          </h2>
          <div
            id="collapseEighteen"
            className={`accordion-collapse collapse ${isOpen.collapseEighteen ? "show" : ""}`}

          //  className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              When AS9100 is implemented in an organization:
              </p>
              <br/>
              <p>
              <ul>
                <li>
                Well defined and documented procedures improve the consistency of output

                </li>
                <li>
                Quality is constantly measured

                </li>
                <li>
                Procedures ensure corrective action is taken whenever defects occur

                </li>
                <li>
                Defect rates decrease

                </li>
                <li>
                Defects are caught earlier and are corrected at a lower cost

                </li>
                <li>
                Defining procedures identifies current practices that are obsolete or inefficient

                </li>
                <li>
                Documented procedures are easier for new employees to follow

                </li>
                <li>
                Organizations retain or increase market share, increasing sales or revenues

                </li>

              </ul>
              </p>

            </div>
          </div>
        </div>
        <br/>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
                className={`accordion-button ${isOpen.collapseNineteen ? "" : "collapsed"}`}
                type="button"
             //   data-bs-toggle="collapse"
               // data-bs-target="#collapseNineteen"
               // aria-expanded="false"
               // aria-controls="collapseNineteen"
                onClick={() => toggleCollapse("collapseNineteen")}
                aria-expanded={isOpen.collapseNineteen ? "true" : "false"}
                aria-controls="collapseNineteen"
                style={isOpen.collapseNineteen ? { backgroundColor: "#0055FF" } : {}}
            >
          TL 9000 (The Telecom quality management systems)


             </button>
          </h2>
          <div
            id="collapseNineteen"
            className={`accordion-collapse collapse ${isOpen.collapseNineteen ? "show" : ""}`}

           // className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              QuEST Forum has pursued a goal of global telecommunications quality and industry-wide 
              performance excellence through its TL 9000 standard. It accomplishes this goal in three ways:
              </p>
              <br/>
              <p>
              By defining system requirements for the design, development, production, delivery, installation 
              and maintenance of telecom products and services and providing a measurement system that allows
              companies to track performance and improve results
              </p>
              <br/>
              <p>
              By eliminating the need for multiple quality management standards, which reduces the cost of 
              doing business and ultimately results in better products and services to consumers
              </p>
              <br/>
              <p>
              By providing a consistent set of quality expectations to drive efficiency and performance 
              across the global telecom supply chain
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
               className={`accordion-button ${isOpen.collapseTwenty ? "" : "collapsed"}`}
               type="button"
            //   data-bs-toggle="collapse"
              // data-bs-target="#collapseTwenty"
              // aria-expanded="false"
              // aria-controls="collapseTwenty"
               onClick={() => toggleCollapse("collapseTwenty")}
               aria-expanded={isOpen.collapseTwenty ? "true" : "false"}
               aria-controls="collapseTwenty"
               style={isOpen.collapseTwenty ? { backgroundColor: "#0055FF" } : {}}
            >
             ISO 18788:2015 Management system for private security operations — Requirements with guidance for use


             </button>
          </h2>
          <div
            id="collapseTwenty"
            className={`accordion-collapse collapse ${isOpen.collapseTwenty ? "show" : ""}`}

          //  className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              This document specifies requirements for establishing, implementing, maintaining and improving an 
              energy management system (EnMS). The intended outcome is to enable an organization to follow
              </p>
              <br/>
              <p>
              It provides the principles and requirements for a security operations management 
              system (SOMS). ISO 18788:2015 provides a business and risk management framework for 
              organizations conducting or contracting security operations and related activities and 
              functions while demonstrating: conduct of professional security operations to meet the requirements of clients and 
              other stakeholders;
              <br/>
              <br/>
              <ul>
                <li>
                	accountability to law and respect for human rights;


                </li>
                <li>
                	consistency with voluntary commitments to which it subscribes.
                </li>
              </ul>
              
              </p>
              <br/>
              <p>
              ISO 18788:2015 is applicable to any organization that needs to:
              <br/>
              
              <ul>
                <li>
                	establish, implement, maintain and improve an SOMS;


                </li>
                <li>
                	assess its conformity with its stated security operations management policy;
                </li>
                <li>
                demonstrate its ability to consistently provide services that meet client needs and are 
                in conformance with applicable laws and human rights requirements.
                </li>
              </ul>

              </p>
              <br/>
            </div>
          </div>
        </div>

        <br/>
       
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseTwentyOne ? "" : "collapsed"}`}
              type="button"
           //   data-bs-toggle="collapse"
             // data-bs-target="#collapseTwentyOne"
             // aria-expanded="false"
             // aria-controls="collapseTwentyOne"
              onClick={() => toggleCollapse("collapseTwentyOne")}
              aria-expanded={isOpen.collapseTwentyOne ? "true" : "false"}
              aria-controls="collapseTwentyOne"
              style={isOpen.collapseTwentyOne ? { backgroundColor: "#0055FF" } : {}}
            >
ISO 20121:2024 - Event sustainability management systems — Requirements with guidance for use

             </button>
          </h2>
          <div
            id="collapseTwentyOne"
            className={`accordion-collapse collapse ${isOpen.collapseTwentyOne ? "show" : ""}`}

          //  className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              ISO 20121 is a beacon for sustainable event management, guiding organizations to seamlessly 
              integrate sustainability into every facet of their event planning and execution. 
              With a keen eye on social, economic, and environmental impacts, this standard is pivotal for 
              events that aspire to leave a lasting positive legacy. This standard applies to events of 
              all types and sizes, encouraging organizations to manage social, economic, and environmental 
              impacts responsibly.

              </p>
              <br/>
              <h4>Why is ISO 20121 important?</h4>
              <br/>
              <p>
              In today's event management, the push for sustainability is paramount. ISO 20121 emerges as a 
              pivotal resource, guiding organizations toward practices that are more ethical, eco-friendly, 
              and socially conscious. Highlighting new focuses on human and children's rights, along with 
              event legacies, the standard showcases sustainability's transformative role in the industry. 
              It offers various conformity demonstration methods, including self-declaration, supplier 
              validation, and third-party certification, making sustainable practices attainable for all 
              organizations, especially SMEs facing certification costs.
              <br/>
              <br/>
              <h4>Benefits</h4>
              <ul>
                <li>
                Reduces environmental impact of events
                </li>
                <li>
                Fosters a holistic approach to sustainability, considering economic, environmental, and social impacts
                </li>
                <li>
                Improves stakeholder engagement and satisfaction
                </li>
                <li>
                Strengthens organizational reputation and brand value
                </li>
                <li>
                Offers versatile pathways for conformity assessment, catering to organizations of all sizes
                </li>
                
              </ul>
              
              </p>
              <br/>
              <h4>Who needs ISO 20121?</h4>
              <p>
              Any organization involved in event planning, management, or delivery, seeking to integrate
               sustainability into their operations.
              <br/>
              
               </p>
              <br/>
            </div>
          </div>
        </div>

        <br/>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseTwentyTwo ? "" : "collapsed"}`}
              type="button"
           //   data-bs-toggle="collapse"
             // data-bs-target="#collapseTwentyTwo"
             // aria-expanded="false"
             // aria-controls="collapseTwentyTwo"
              onClick={() => toggleCollapse("collapseTwentyTwo")}
              aria-expanded={isOpen.collapseTwentyTwo ? "true" : "false"}
              aria-controls="collapseTwentyTwo"
              style={isOpen.collapseTwentyTwo ? { backgroundColor: "#0055FF" } : {}}
            >
              ISO 46001:2019 - Water efficiency management systems — Requirements with guidance for use
             </button>
          </h2>
          <div
            id="collapseTwentyTwo"
            className={`accordion-collapse collapse ${isOpen.collapseTwentyTwo ? "show" : ""}`}

            //className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              This document specifies requirements and contains guidance for its use in establishing, 
              implementing and maintaining a water efficiency management system. It is applicable to 
              organizations of all types and sizes that use water. It is focused on end-use consumers.
              </p>
              <br/>
              
              
              <p>This document is applicable to any organization that wishes to:
                <br/>
                <br/>
              <ul>
                <li>
                achieve the efficient use of water through the reduce, replace or reuse' approach;
                </li>
                <li>
                establish, implement and maintain water efficiency;
                </li>
                <li>
                continually improve water efficiency.
                </li>
               
              </ul>
              
              </p>
              <br/>
              
              <p>
              This document specifies requirements and contains guidance for its use regarding 
              organizational water use. It includes monitoring, measurement, documentation, reporting, 
              design and procurement practices for equipment, systems, processes and personnel training 
              that contribute to water efficiency management.
              <br/>
              <br/>
              NOTE 1.  Reduce' includes the use of water-efficient fittings and equipment and, for example, 
              putting in place a proper monitoring system for usage and leak detection.
              <br/>
              <br/>

              NOTE 2. Replace' includes substitution of drinking water with reclaimed water, sea water and 
              rainwater wherever feasible.
              <br/>
              <br/>

              NOTE 3. Reuse' includes recycling of, for example, process water or grey water. 
              For utilizing water reuse systems, ISO/TC 282 documents can be referred to as guidelines.
              <br/>
              <br/>

              NOTE 4. Guidance in the annexes provides additional practical information to support implementation.
              Annex A provides guidance on the use of this document and Annex B gives examples of scenarios in water efficiency.
               </p>
              <br/>
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
               className={`accordion-button ${isOpen.collapseTwentyThree ? "" : "collapsed"}`}
               type="button"
            //   data-bs-toggle="collapse"
              // data-bs-target="#collapseTwentyThree"
              // aria-expanded="false"
              // aria-controls="collapseTwentyThree"
               onClick={() => toggleCollapse("collapseTwentyThree")}
               aria-expanded={isOpen.collapseTwentyThree ? "true" : "false"}
               aria-controls="collapseTwentyThree"
               style={isOpen.collapseTwentyThree ? { backgroundColor: "#0055FF" } : {}}
            >
              ISO 55001:2024 - Asset management system — Requirements
             </button>
          </h2>
          <div
            id="collapseTwentyThree"
            className={`accordion-collapse collapse ${isOpen.collapseTwentyThree ? "show" : ""}`}

          //  className="accordion-collapse collapse"
          
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              ISO 55001 is a critical part of the ISO 55000 family of standards, focusing 
              specifically on the requirements for a robust asset management system. 
              This standard details the criteria necessary for establishing, implementing, 
              maintaining, and improving an asset management system. It builds upon the principles 
              outlined in ISO 55000 by providing specific requirements that organizations need to 
              meet to achieve their asset management objectives effectively and efficiently.
              <br/>
              <br/>
              ISO 55001 is vital because it provides a clear structure for organizations to 
              manage their assets systematically and sustainably. Effective asset management 
              as prescribed by ISO 55001 helps organizations control the lifecycle of assets, 
              ensuring that the performance, risk, and expenditure related to assets are balanced 
              to meet organizational goals. This standard is crucial for organizations looking to 
              maximize value through their asset management processes while minimizing operational 
              risks and costs, thereby enhancing overall organizational performance and stakeholder
              satisfaction.


              </p>
              <br/>
              <p>
              <h4>Benefits</h4>
                <br/>
              <ul>
                <li>
                Optimized asset lifecycle: Aligns organizational objectives with the asset management system to maximize asset efficiency and value
                </li>
                <li>
                Enhanced financial performance: Manages asset-related costs and risks to improve profitability and efficiency
                </li>
                <li>
                	Sustainability: Promotes responsible resource utilization and sustainable asset management practices
                </li>
                <li>
                	Reputation and reliability: Demonstrates effective risk management and reliability to stakeholders 
                </li>
               
              </ul>
              
              <br/>
              <h4>Who should use ISO 55001?</h4>
              <br/>
              ISO 55001 is suitable for any organization that relies on assets to achieve business objectives.
              This includes entities in sectors such as manufacturing, utilities, transportation, and public 
              service, among others.
              </p>
              </div>
          </div>
        </div>


        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
               className={`accordion-button ${isOpen.collapseTwentyFour ? "" : "collapsed"}`}
               type="button"
            //   data-bs-toggle="collapse"
              // data-bs-target="#collapseTwentyFour"
              // aria-expanded="false"
              // aria-controls="collapseTwentyFour"
               onClick={() => toggleCollapse("collapseTwentyFour")}
               aria-expanded={isOpen.collapseTwentyFour ? "true" : "false"}
               aria-controls="collapseTwentyFour"
               style={isOpen.collapseTwentyFour ? { backgroundColor: "#0055FF" } : {}}
            >
             ISO 37001:2016 - Anti-bribery management systems — Requirements with guidance for use
             </button>
          </h2>
          <div
            id="collapseTwentyFour"
            
          //  className="accordion-collapse collapse"
          className={`accordion-collapse collapse ${isOpen.collapseTwentyFour ? "show" : ""}`}

            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              ISO 37001:2016 specifies requirements and provides guidance for establishing, implementing, 
              maintaining, reviewing and improving an anti-bribery management system. The system can be 
              stand-alone or can be integrated into an overall management system. ISO 37001:2016 addresses 
              the following in relation to the organization's activities:
              <br/>
              <br/>
              <ul>
                <li>
                	bribery in the public, private and not-for-profit sectors
                </li>
                <li>
                	bribery by the organization
                </li>
                <li>
                bribery by the organization's personnel acting on the organization's behalf or for its benefi
                </li>
                <li>
                	bribery by the organization's business associates acting on the organization's behalf or for its benefit 
                </li>
               <li>
               	bribery of the organization
               </li>
               <li>
               bribery of the organization's personnel in relation to the organization's activities
               </li>
               <li>
               	bribery of the organization's business associates in relation to the organization's activities
               </li>
               <li>
               direct and indirect bribery (e.g. a bribe offered or accepted through or by a third party)
               </li>
              </ul>
              <br/>
              <p>
              ISO 37001:2016 is applicable only to bribery. It sets out requirements and provides guidance 
              for a management system designed to help an organization to prevent, detect and respond to 
              bribery and comply with anti-bribery laws and voluntary commitments applicable to its activities.

              </p>
              <br/>
              <p>
              ISO 37001:2016 does not specifically address fraud, cartels and other anti-trust/competition 
              offences, money-laundering or other activities related to corrupt practices, although an 
              organization can choose to extend the scope of the management system to include such activities.
              </p>
              <br/>
              ISO 55001 is suitable for any organization that relies on assets to achieve business objectives.
              This includes entities in sectors such as manufacturing, utilities, transportation, and public 
              service, among others.
              
              <br/>
              The requirements of ISO 37001:2016 are generic and are intended to be applicable to all 
              organizations (or parts of an organization), regardless of type, size and nature of activity, 
              and whether in the public, private or not-for-profit sectors. The extent of application of 
              these requirements depends on the factors specified in 4.1, 4.2 and 4.5.
              </p>

              </div>
          </div>
        </div>
        <br/>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
             className={`accordion-button ${isOpen.collapseTwentyFive ? "" : "collapsed"}`}
             type="button"
          //   data-bs-toggle="collapse"
            // data-bs-target="#collapseTwentyFive"
            // aria-expanded="false"
            // aria-controls="collapseTwentyFive"
             onClick={() => toggleCollapse("collapseTwentyFive")}
             aria-expanded={isOpen.collapseTwentyFive ? "true" : "false"}
             aria-controls="collapseTwentyFive"
             style={isOpen.collapseTwentyFive ? { backgroundColor: "#0055FF" } : {}}
            >
ISO 7101:2023 - Healthcare organization management — Management systems for quality in healthcare organizations — Requirements
             </button>
          </h2>
          <div
            id="collapseTwentyFive"
           // className="accordion-collapse collapse"
           className={`accordion-collapse collapse ${isOpen.collapseTwentyFive ? "show" : ""}`}

            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
                <h4>What is ISO 7101?</h4>
                <br/>
              ISO 7101 is the first international consensus standard for healthcare quality management. 
              It prescribes requirements for a systematic approach to sustainable, high quality health systems,
               enabling organizations of any scale, structure, or region to:
              <br/>
              <br/>
              <ul>
                <li>
                create a culture of quality starting with strong top management; 
                </li>
                <li>
                embrace a healthcare system based on people-centred care, respect, compassion, co-production, equity and dignity
                </li>
                <li>
                	identify and address risks
                </li>
                <li>
                ensure patient and workforce safety and wellbeing
                </li>
               <li>
               control service delivery through documented processes and documented information
               </li>
               <li>
               	monitor and evaluate clinical and non-clinical performance
               </li>
               <li>
               continually improve its processes and results.
               </li>
              
              </ul>
              <br/>

              <h4>Why is ISO 7101 important? </h4>
              <p>
              Healthcare organizations around the world have been facing significant threats for several years, 
              such as decreasing financial resources, workforce shortages, an increase in the number of 
              people needing care as a result of ageing populations, increasing rates of chronic disease, 
              lack of data for decision making, scarcity of, or inadequate, medical equipment and medications,
               and an absence of clear healthcare system governance.
              </p>
              <br/>
             <br/>
             <h4>Benefits</h4>
             <ul>
              <li>
              Refined quality of healthcare delivery.
              </li>
              <li>
              	Improved patient safety.
              </li>
              <li>
              	Cost-efficiency.
              </li>
              <li>
              Enhanced operational effectiveness.
              </li>
              <li>
              Strengthened reputation and extended market reach.
              </li>
             </ul>
             <br/>
             <h4>Who is ISO 7107 designed for</h4>
             <br/>
             ISO 7101 has been written with a focus on providing requirements for healthcare 
             quality management. As such, its targeted audience is broad, including any healthcare 
             system, organization, or entity that aims to increase the quality of its healthcare 
             delivery and care outcomes. 


              </p>

              </div>
          </div>
        </div>
        <br/>
       
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseTwentySix ? "" : "collapsed"}`}
              type="button"
           //   data-bs-toggle="collapse"
             // data-bs-target="#collapseTwentySix"
             // aria-expanded="false"
             // aria-controls="collapseTwentySix"
              onClick={() => toggleCollapse("collapseTwentySix")}
              aria-expanded={isOpen.collapseTwentySix ? "true" : "false"}
              aria-controls="collapseTwentySix"
              style={isOpen.collapseTwentySix ? { backgroundColor: "#0055FF" } : {}}
            >
ISO/IEC 42001:2023 - Information technology — Artificial intelligence — Management system
             </button>
          </h2>
          <div
            id="collapseTwentySix"
          //  className="accordion-collapse collapse"
          className={`accordion-collapse collapse ${isOpen.collapseTwentySix ? "show" : ""}`}

            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
                <h4>What is ISO/IEC 42001?</h4>
                <br/>
                ISO/IEC 42001 is an international standard that specifies requirements for establishing, 
                implementing, maintaining, and continually improving an Artificial Intelligence Management 
                System (AIMS) within organizations. It is designed for entities providing or utilizing 
                AI-based products or services, ensuring responsible development and use of AI systems.

              <br/>
              <br/>
              <h4>Why is ISO/IEC 42001 important?</h4>
              <br/>
              <p>
              ISO/IEC 42001 is the world’s first AI management system standard, providing valuable guidance
               for this rapidly changing field of technology. It addresses the unique challenges AI poses, 
               such as ethical considerations, transparency, and continuous learning. For organizations, 
               it sets out a structured way to manage risks and opportunities associated with AI, balancing 
               innovation with governance.
              </p>
              <br/>
              <br/>
              <h4>Benefits</h4>
              <ul>
                <li>
                	Framework for managing risk and opportunities
                </li>
                <li>
                	Demonstrate responsible use of AI
                </li>
                <li>
                Traceability, transparency and reliability
                </li>
                <li>
                Cost savings and efficiency gains
                </li>
              
              
              </ul>
              <br/>

              <h4>Who is ISO/IEC 42001 for?</h4>
              <p>
              Organizations of any size involved in developing, providing, or using AI-based products or 
              services. It is applicable across all industries and relevant for public sector agencies as 
              well as companies or non-profits.
              </p>
              <br/>
             <br/>
              </p>

              </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
               className={`accordion-button ${isOpen.collapseTwentySeven ? "" : "collapsed"}`}
               type="button"
            //   data-bs-toggle="collapse"
              // data-bs-target="#collapseTwentySeven"
              // aria-expanded="false"
              // aria-controls="collapseTwentySeven"
               onClick={() => toggleCollapse("collapseTwentySeven")}
               aria-expanded={isOpen.collapseTwentySeven ? "true" : "false"}
               aria-controls="collapseTwentySeven"
               style={isOpen.collapseTwentySeven ? { backgroundColor: "#0055FF" } : {}}
            >
ISO 28000:2022 - Security and resilience — Security management systems — Requirements
             </button>
          </h2>
          <div
            id="collapseTwentySeven"
           // className="accordion-collapse collapse"
           className={`accordion-collapse collapse ${isOpen.collapseTwentySeven ? "show" : ""}`}

            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
                
              This document specifies requirements for a security management system, including aspects relevant 
              to the supply chain.
              <br/>
              <br/>

              This document is applicable to all types and sizes of organizations (e.g. commercial 
              enterprises, government or other public agencies and non-profit organizations) which intend to
               establish, implement, maintain and improve a security management system. It provides a 
               holistic and common approach and is not industry or sector specific.
              <br/>
              <br/>

              This document can be used throughout the life of the organization and can be applied to any 
              activity, internal or external, at all levels.
                            </p>

              </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
             className={`accordion-button ${isOpen.collapseTwentyEight ? "" : "collapsed"}`}
             type="button"
          //   data-bs-toggle="collapse"
            // data-bs-target="#collapseTwentyEight"
            // aria-expanded="false"
            // aria-controls="collapseTwentyEight"
             onClick={() => toggleCollapse("collapseTwentyEight")}
             aria-expanded={isOpen.collapseTwentyEight ? "true" : "false"}
             aria-controls="collapseTwentyEight"
             style={isOpen.collapseTwentyEight ? { backgroundColor: "#0055FF" } : {}}
            >
ISO 24014-1:2021 - Public transport — Interoperable fare management system
             </button>
          </h2>
          <div
            id="collapseTwentyEight"
         //   className="accordion-collapse collapse"
         className={`accordion-collapse collapse ${isOpen.collapseTwentyEight ? "show" : ""}`}

            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
                             
              This document gives guidelines for the development of multi-operator/multi-service interoperable public surface (including subways) transport fare management systems (IFMSs) on a national and international level.
<br/>
<br/>

This document is applicable to bodies in public transport and related services which agree that their systems need to interoperate.
<br/>
<br/>

This document defines a conceptual framework which is independent of organizational and physical implementation. Any reference within this document to organizational or physical implementation is purely informative.
<br/>
<br/>

This document defines a reference functional architecture for IFMSs and establishes the requirements that are relevant for ensuring interoperability between several actors in the context of the use of electronic tickets.
<br/>
<br/>

The IFMS includes all the functions involved in the fare management process, such as:

              <br/>
              <br/>
              <ul>
                <li>
                	management of media,
                </li>
                <li>
                management of applications,
                </li>
                <li>
                	management of products,
                </li>
                <li>
                	security management, and
                </li>
                <li>
                certification, registration, and identification.
                </li>
              
              
              </ul>
              <br/>

              <p>
              This document defines the following main elements:
              </p>
              <br/>
              <ul>
                <li>
                identification of the different sets of functions in relation to the overall IFMS and services and media from non-transport systems which interact with fare management systems;
                </li>
                <li>
                a generic model of an IFMS describing the logical and functional architecture and the interfaces within the system, with other IFMSs and with services and media from non-transport systems;
                </li>
                <li>	use cases describing the interactions and data flows between the different sets of functions;</li>
                <li>	security requirements.</li>


              </ul>
             <br/>
             In its annexes, this document provides a framework for mobility platforms that integrate fare management and travel information for inter- and multimodal travel (see Annex A). It also elaborates on specific subjects covered in document and offers some national examples with regard to IFMS implementations (see Annex B, Annex C, Annex D and Annex E).
              <br/>
              <br/>
              This document does not define:
              <br/>
              <br/>
              <ul>
                <li>
                	the technical aspects of the interface between the medium and the medium access device;
                </li>
                <li>
                the data exchanges between the medium and the medium access device;

                </li>
              </ul>
              <br/>
              NOTE The data exchanges between the medium and the medium access device are proposed by other standardization committees.
             <br/>
             <br/>
              <ul>
                <li>
                	the financial aspects of fare management systems (e.g. customer payments, method of payment, settlement, apportionment, reconciliation).
                </li>
                
              </ul>
              </p>

              </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseTwentyNine ? "" : "collapsed"}`}
              type="button"
           //   data-bs-toggle="collapse"
             // data-bs-target="#collapseTwentyNine"
             // aria-expanded="false"
             // aria-controls="collapseTwentyNine"
              onClick={() => toggleCollapse("collapseTwentyNine")}
              aria-expanded={isOpen.collapseTwentyNine ? "true" : "false"}
              aria-controls="collapseTwentyNine"
              style={isOpen.collapseTwentyNine ? { backgroundColor: "#0055FF" } : {}}
            >
ISO 19443:2018 Quality management systems             </button>
          </h2>
          <div
            id="collapseTwentyNine"
           // className="accordion-collapse collapse"
           className={`accordion-collapse collapse ${isOpen.collapseTwentyNine ? "show" : ""}`}

            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              Specific requirements for the application of ISO 9001:2015 by organizations in the supply chain of the nuclear energy sector supplying products and services important to nuclear safety (ITNS)
              
              </p>

              </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
             className={`accordion-button ${isOpen.collapseThirty ? "" : "collapsed"}`}
             type="button"
          //   data-bs-toggle="collapse"
            // data-bs-target="#collapseThirty"
            // aria-expanded="false"
            // aria-controls="collapseThirty"
             onClick={() => toggleCollapse("collapseThirty")}
             aria-expanded={isOpen.collapseThirty ? "true" : "false"}
             aria-controls="collapseThirty"
             style={isOpen.collapseThirty ? { backgroundColor: "#0055FF" } : {}}
            >
SA8000, or Social Accountability 8000
             </button>
          </h2>
          <div
            id="collapseThirty"
        //    className="accordion-collapse collapse"
        className={`accordion-collapse collapse ${isOpen.collapseThirty ? "show" : ""}`}

            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              Is a voluntary certification program that encourages companies to adopt socially responsible practices in the workplace. It was created in 1989 by Social Accountability International (SAI), a non-governmental organization that promotes human rights at work.
              <br/>
              <br/>
              SA8000 is based on international human rights norms and ISO standards. It measures a company's performance in eight areas, including: 
            
              <br/>
              <br/>
              
              <ul>
                <li>
                Child labor
                </li>
                <li>
                	Forced labor
                </li>
                <li>
                Health and safety
	
             </li>
                <li>
                	Free association and collective bargaining
                </li>
              <li>Discrimination</li>
              
              <li>Disciplinary practices</li>
              <li>Working hours</li>
              <li>Compensation</li>
              </ul>
              <br/>

              <p>
              Benefits of SA8000 certification include: Improved working conditions and worker well-being, Better productivity, Improved stakeholder relationships and market access, Demonstrating good practice, and Fostering a culture of continuous improvement. 
              </p>
              <br/>
             SA8000 is comparable in structure to ISO 9001 and ISO 14001 management norms. 
              </p>

              </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseThirtyOne ? "" : "collapsed"}`}
              type="button"
           //   data-bs-toggle="collapse"
             // data-bs-target="#collapseThirtyOne"
             // aria-expanded="false"
             // aria-controls="collapseThirtyOne"
              onClick={() => toggleCollapse("collapseThirtyOne")}
              aria-expanded={isOpen.collapseThirtyOne ? "true" : "false"}
              aria-controls="collapseThirtyOne"
              style={isOpen.collapseThirtyOne ? { backgroundColor: "#0055FF" } : {}}
            >
FSC CoC              </button>
          </h2>
          <div
            id="collapseThirtyOne"
         //   className="accordion-collapse collapse"
         className={`accordion-collapse collapse ${isOpen.collapseThirtyOne ? "show" : ""}`}

            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              FSC is a non-profit organization, providing trusted solutions to help protect the world’s forests and tackle today’s deforestation, climate, and biodiversity challenges.
              <br/>
             <br/>
             Currently, over 150 million hectares of forest worldwide is certified according to FSC standards, designed to address a broad range of environmental, social, and economic factors.
             <br/>
             <br/>
             <h4>Why forests matter</h4>
             
             Healthy and resilient forests are the first line of defence against the climate and biodiversity crises. Learn how sustainable forestry supports thriving forests and why stewardship is more important than ever. 
              </p>

              </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
             className={`accordion-button ${isOpen.collapseThirtyTwo ? "" : "collapsed"}`}
             type="button"
          //   data-bs-toggle="collapse"
            // data-bs-target="#collapseThirtyTwo"
            // aria-expanded="false"
            // aria-controls="collapseThirtyTwo"
             onClick={() => toggleCollapse("collapseThirtyTwo")}
             aria-expanded={isOpen.collapseThirtyTwo ? "true" : "false"}
             aria-controls="collapseThirtyTwo"
             style={isOpen.collapseThirtyTwo ? { backgroundColor: "#0055FF" } : {}}
            >
Environmental, social, and governance (ESG) – (International Workshop Agreement) 
IWA 48:2024, 1st Edition
             </button>
          </h2>
          <div
            id="collapseThirtyTwo"
           // className="accordion-collapse collapse"
           className={`accordion-collapse collapse ${isOpen.collapseThirtyTwo ? "show" : ""}`}

            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              ISO's ESG Implementation Principles (IWA 48) is a high-level structure and set of principles designed to guide organizations in implementing and embedding Environmental, Social, and Governance (ESG) practices within their organizational culture. This document supports the management of ESG performance and facilitates measurement and reporting under existing frameworks, enabling consistency, comparability, and reliability of ESG reporting and practices globally.
              <br/>
              <br/>
              <h4>Why are the ISO ESG Implementation Principles important?</h4>
              <br/>
              <p>
              These principles serve as a universal language for ESG practices, establishing an international reference model that ensures global interoperability and reliability in ESG reporting and practices. This standardized guidance is key to fostering a lasting culture of ESG within organizations and businesses worldwide. The ISO ESG Implementation Principles not only helps individual organizations improve their ESG performance but also accelerates the global adoption of sustainable business practices, contributing to a more resilient and responsible business ecosystem worldwide.
              </p>
              <br/>
              <br/>
              <h4>Benefits</h4>
              <ul>
                <li>
                	<b>Gain a competitive edge:</b> By implementing robust ESG practices, organizations can attract socially conscious customers and investors, potentially opening up new markets and funding opportunities
                </li>
                <li>
                <b>Enhance reputation and trust:</b> Improved ESG performance leads to greater transparency and stakeholder trust, bolstering an organization's reputation in the market and community
	


                </li>
                <li>
                <b> Mitigate risks:</b> A comprehensive approach to ESG helps organizations identify and address potential environmental, social, and governance risks before they become costly issues                </li>
                <li>
                <b> Contribute to global sustainability:</b> By aligning with global sustainability goals, organizations can play a meaningful role in addressing pressing global challenges, from climate change to social inequality

                </li>
              
              
              </ul>
              <br/>

              </p>

              </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseThirtyThree ? "" : "collapsed"}`}
              type="button"
           //   data-bs-toggle="collapse"
             // data-bs-target="#collapseThirtyThree"
             // aria-expanded="false"
             // aria-controls="collapseThirtyThree"
              onClick={() => toggleCollapse("collapseThirtyThree")}
              aria-expanded={isOpen.collapseThirtyThree ? "true" : "false"}
              aria-controls="collapseThirtyThree"
              style={isOpen.collapseThirtyThree ? { backgroundColor: "#0055FF" } : {}}
            >
ISO 3834 Quality requirements for welding 
             </button>
          </h2>
          <div
            id="collapseThirtyThree"
           // className="accordion-collapse collapse"
           className={`accordion-collapse collapse ${isOpen.collapseThirtyThree ? "show" : ""}`}

            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
               
              A standard that guides manufacturers in managing welding fabrication activities from design to delivery. It defines three levels of welding quality: comprehensive, standard, and elementary.
                             </p>

              </div>
          </div>
        </div>
      
      
        <br/>
       
        <br/>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen.collapseThirtyFour ? "" : "collapsed"}`}
              type="button"
           //   data-bs-toggle="collapse"
             // data-bs-target="#collapseThirtyFour"
             // aria-expanded="false"
             // aria-controls="collapseThirtyFour"
              onClick={() => toggleCollapse("collapseThirtyFour")}
              aria-expanded={isOpen.collapseThirtyFour ? "true" : "false"}
              aria-controls="collapseThirtyFour"
              style={isOpen.collapseThirtyFour ? { backgroundColor: "#0055FF" } : {}}
            >
                  SEDEX – 2 pillar / 4 pillar
             </button>
          </h2>
          <div
            id="collapseThirtyFour"
           // className="accordion-collapse collapse"
           className={`accordion-collapse collapse ${isOpen.collapseThirtyFour ? "show" : ""}`}

            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
               
              A Sedex audit, also known as a SMETA (Sedex Members Ethical Trade Audit), is a comprehensive 
              assessment conducted by a third-party auditor to evaluate a company's ethical and responsible 
              sourcing practices within its supply chain, focusing on key areas like labor standards, health 
              and safety, environmental impact, and business ethics, with the goal of promoting transparency 
              and accountability in the global marketplace

              <br/>
              <br/>

              <h4>Purpose:</h4>

              To ensure companies adhere to internationally recognized ethical standards in their 
              operations, demonstrating commitment to fair labor practices, worker well-being, 
              environmental sustainability, and ethical business conduct throughout their supply 
              chain.
              <br/>
              <br/>

              <h4>Who uses it:</h4>
              
              Primarily used by businesses across various industries to assess their suppliers, 
              allowing buyers to identify potential risks and ensure responsible sourcing practices.
              <br/>
              <br/>

              <h4>Audit methodology:</h4>

              The SMETA audit framework is used, which includes a set of standardized questions and 
              criteria covering the four main pillars:
              <br/>
              <br/>
              <p>
                <ul>
                  <li>
                  <b>Labor Standards:</b> Working hours, wages, child labor, forced labor, discrimination, freedom of association.
                  </li>
                  <li>
                  <b>Health and Safety:</b>
                  Workplace safety measures, emergency preparedness, access to healthcare.
                  </li>
                  <li>
                  <b>Environment:</b>  Waste management, energy consumption, pollution control, resource usage.
                  </li>
                  <li>
                  <b>Business Ethics: </b> Bribery, corruption, compliance with local laws, ethical business practices.
                  </li>
                </ul>
              </p>

              <br/>

                </p>

              </div>
          </div>
        </div>
      
      
        <br/>
       <br/>
        <p>
        These ISO standards collectively represent a roadmap for achieving operational excellence. 
        They enable organizations to enhance efficiency, meet compliance obligations, foster 
        innovation, and build trust with stakeholders. By adopting these internationally 
        recognized frameworks, businesses can secure a competitive edge, contribute to global 
        sustainability efforts, and ensure long-term success in their respective industries.

        <br/>
        <br/>

        <Link to = "/contact">Contact us</Link> to know more.
        </p>
      </div>
    </div>
  );

  
};
